export const CONTROL_KEYS = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
            'Tab', 'Enter', 'Home', 'End', 'PageUp', 'PageDown', 'Escape',
             'Shift', 'Control', 'Alt', 'Meta'];

export const COMMAND_KEYS = ['a', 'c', 'v', 'x', 'z'];